export default __webpack_public_path__ + "static/media/Bracers of the Howling Giant.d21771d9.jpg";